import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import Home from './Home';
import Header from './Header';
import AboutSection from './Component/AboutSection';
import Services from './Component/Services';
import RealtorServices from './Component/RealtorServices';
import Contact from './Component/Contact';
import ContactUs from './Component/Contact';
import Footer from './Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <div className="min-h-screen flex flex-col">
                <Header />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/AboutSection" element={<AboutSection />} />
                        <Route path="/Services" element={<Services />} />
                        <Route path="/RealtorServices" element={<RealtorServices />} />
                        <Route path="/Contact" element={<Contact />} />
                        <Route path="/ContactUs" element={<ContactUs />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </BrowserRouter>
    </React.StrictMode>
);
